<template>
  <div ref="mapContainer"></div>
</template>
<script>
import { createMapAdapter, getMapProvider, googleZoomToKakaoLevel, loadMapApi } from '../../util/mapProvider'

export default {
  name: 'GoogleMap',
  props: {
    center: {
      type: Object,
      default: function () {
        return { lat: null, lng: null }
      }
    },
    zoom: {
      type: Number,
      default: 16
    },
    mapTypeId: {
      type: String,
      default: 'hybrid'
    }
  },
  data () {
    return {
      map: null,
      adapter: null,
      provider: null,
      initToken: 0
    }
  },
  mounted () {
    this.initializeMap()
  },
  methods: {
    initializeMap () {
      const hasCenter = this.center && this.center.lat != null && this.center.lng != null
      const center = hasCenter
        ? { lat: Number(this.center.lat), lng: Number(this.center.lng) }
        : { lat: 37.5665, lng: 126.978 }
      const provider = getMapProvider(this.$i18n.locale)
      const token = ++this.initToken

      loadMapApi(provider).then(maps => {
        if (token !== this.initToken) return
        this.provider = provider
        if (provider === 'kakao') {
          this.map = new maps.Map(this.$refs.mapContainer, {
            center: new maps.LatLng(center.lat, center.lng),
            level: googleZoomToKakaoLevel(this.zoom),
            mapTypeId: maps.MapTypeId.HYBRID
          })
          this.map.addControl(new maps.MapTypeControl(), maps.ControlPosition.TOPRIGHT)
        } else {
          this.map = new maps.Map(this.$refs.mapContainer, {
            center,
            zoom: this.zoom,
            mapTypeId: this.mapTypeId,
            mapTypeControl: true,
            mapTypeControlOptions: {
              position: maps.ControlPosition.TOP_RIGHT
            },
            streetViewControl: false,
            fullscreenControl: false
          })
        }
        this.adapter = createMapAdapter(provider, maps, this.map)
        this.$emit('load', this.adapter)
      }).catch(error => {
        console.log('loadMapApi.err.===>', error)
      })
    }
  },
  watch: {
    center: {
      deep: true,
      handler (value) {
        if (this.adapter && value && value.lat != null && value.lng != null) {
          this.adapter.setCenter(value.lat, value.lng)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/GoogleMap.vue